import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';

import { MarketArea } from '@scenario/models/market-area.model';
import { RootState } from '@store/create-store';

export interface MarketAreasState {
  marketAreas: MarketArea[];
  isFetching: boolean;
  error?: string;
}

const initialState: MarketAreasState = {
  marketAreas: [],
  isFetching: false,
};

export const marketAreasSlice = createSlice({
  name: 'marketAreas',
  initialState,
  reducers: {
    retrieveMarketAreas: state => {
      state.isFetching = true;
    },
    retrieveMarketAreasSuccess: (state, action: PayloadAction<MarketArea[]>) => {
      state.marketAreas = action.payload;
      state.isFetching = false;
    },
    retrieveMarketAreasFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type MarketAreasViewModel = {
  marketAreas: MarketArea[];
  isFetching: boolean;
  error?: string;
};

export const selectMarketAreasViewModel = createSelector(
  (state: RootState) => state,
  (state): MarketAreasViewModel => ({
    marketAreas: state.marketAreas.marketAreas,
    isFetching: state.marketAreas.isFetching,
    error: state.marketAreas.error,
  }),
);

export const { retrieveMarketAreas, retrieveMarketAreasSuccess, retrieveMarketAreasFailure } =
  marketAreasSlice.actions;

export default marketAreasSlice.reducer;
